import { network } from 'services/network';
import { useMutation } from 'react-query';

const setCheckMandatorily = (params) => {
    return network.post('api/bo/setCheckMandatorily', params).then((response) => {
        return response.data;
    });
};
export const useMutationSetCheckMandatory = () => {
    return useMutation<
        boolean,
        QueryError,
        {
            checkId: number;
            mandatory: boolean;
            metaDataId: number;
        }
    >((params) => setCheckMandatorily(params));
};
